import SidebarLayout from '../../components/SidebarLayout';
import AssessmentsUpdateForm from '../../components/sections/MTSS/AssessmentsUpdateForm';
import AccessWrapper from '../../components/AccessWrapper';
import AuthContext from '../../context/AuthContext';
import React, { useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';

export default function AssessmentsUpdate() {
  const params = useParams();
  const id = params?.id;
  const { postPageView, user, baseUrl } = useContext(AuthContext);

  useEffect(() => {
    postPageView(baseUrl, user.name, user.role, 'form/update-assessment');
  }, []);
  return (
    <AccessWrapper allowedGroups={['mtss_admin']}>
      <div>
        <SidebarLayout
          propComponents={<AssessmentsUpdateForm params={id} />}
          heading={'Update Assessment'}
        />
      </div>
    </AccessWrapper>
  );
}
